import { Component, Input } from '@angular/core';

/**
 * @Component <app-with-tooltip></<app-with-tooltip>
 * It does the following:
 *  - attaches the tooltip to the text
 *  - Adds CSS classes of overflow elippses to large text
 *  - shows help cursor on demand
 *
 * @input :
 *  - <ng-content>:  the content to attach tooltip to and to apply css classes
 * - showHelpCursor: wheather to show the help cursor or not
 *
 * @usage
 * <app-with-tooltip [showHelpCursor]><p>my long text</p></<app-with-tooltip>
 */
@Component({
  selector: 'app-with-tooltip',
  templateUrl: './with-tooltip.component.html',
  styleUrls: ['./with-tooltip.component.scss'],
})
export class WithTooltipComponent {
  @Input() showHelpCursor: boolean = false;

  constructor() {}
}
